import { Component, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Icon } from '../svg-icon/icons.map';

@Component({
  selector: 'sky-input[formControl]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: SkyInputFormControlComponent,
    },
  ],
  templateUrl: './input-form-control.component.html',
  styleUrls: ['./input-form-control.component.scss'],
})
export class SkyInputFormControlComponent implements ControlValueAccessor {
  @Input() public label = '';
  @Input() public placeholder = '';
  @Input() public acceptPattern: RegExp | null = null;
  @Input() public icon?: Icon;
  @Input() public tooltip?: string;
  @Input() public prefix = '';
  @Input() public inputType: string = 'text';
  @Input() public formControl!: FormControl;

  public onChange: unknown;
  public value: unknown;
  public focused = false;

  public testUserInput(event: KeyboardEvent): void {
    if (this.acceptPattern === null || this.acceptPattern.test(event.key) || this.isUserPasteWithKeyboard(event)) {
      return;
    }

    event.preventDefault();
  }

  public writeValue(value: unknown) {
    this.value = value;
  }
  public registerOnChange(fn: unknown) {
    this.onChange = fn;
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public registerOnTouched(fn: unknown) {}

  private isUserPasteWithKeyboard(event: KeyboardEvent): boolean {
    return event.ctrlKey && event.key.toLowerCase() === 'v';
  }
}
